import { JobPhaseReceivableUpdatableInterface } from '../interfaces/job-phase-receivable-updatable.interface';
import { JobPhaseReceivableDto } from './job-phase-receivable.dto';
import { PartialType, PickType } from '@nestjs/swagger';

export class JobPhaseReceivableUpdateDto
  extends PartialType(
    PickType(JobPhaseReceivableDto, [
      'supplyProIntegrated',
      'billed',
      'invoicePOAmount',
      'internalInvoiceNumber',
    ] as const),
  )
  implements JobPhaseReceivableUpdatableInterface {}
